import React from 'react';
import { useRealtime } from '@/context/RealtimeContext';

/** "Online now" chips for the dashboard header. */
export const OnlineNow = () => {
  const { online, connected, me } = useRealtime();
  if (!connected || online.length === 0) return null;

  return (
    <div
      className="hidden sm:flex items-center gap-2 rounded-full border border-emerald-300 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-950/50 pl-2 pr-3 py-1"
      data-testid="online-now"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
      </span>
      <span className="text-[11px] font-semibold text-emerald-800 dark:text-emerald-200">
        Online now
      </span>
      <div className="flex items-center gap-1">
        {online.slice(0, 4).map((user) => (
          <span
            key={user.email}
            title={`${user.name}${user.email === me?.email ? ' (you)' : ''} · ${user.email}`}
            className="h-5 w-5 rounded-full bg-emerald-600 text-white text-[9px] font-bold flex items-center justify-center"
            data-testid={`online-chip-${user.email}`}
          >
            {(user.name || user.email).charAt(0).toUpperCase()}
          </span>
        ))}
        {online.length > 4 && (
          <span className="text-[10px] text-emerald-800 dark:text-emerald-200">
            +{online.length - 4}
          </span>
        )}
      </div>
    </div>
  );
};

export default OnlineNow;
